




























































import Pagination from "@/components/Pagination/index.vue"; // Secondary package based on el-pagination
import { Vue, Component } from "vue-property-decorator";
import path from "path";
import { deepClone } from "@/utils";
import { asyncRoutes } from "@/router";
import i18n from "@/lang";
import {
  users,
  updateUser,
  registerUser,
  RegisterReq,
  createInstallUser,
  CreateInstallUserReq,
  UserReq,
} from "@/api/user";
import { RouteConfig } from "vue-router";
import { ResCode, PagingReq, User, Company, Admin } from "@/api/baseDefine";
import { ElTree, TreeData } from "element-ui/types/tree";
import { UserModule } from "@/store/modules/user";
import { ElStep } from "element-ui/types/step";
import { CompanyCommonReq, geCompanys } from "@/api/company";
import { ElForm } from "element-ui/types/form";

/**
 * 包含所有功能的表单
 *
 * @export
 * @class ComplexTable
 * @extends {Vue}
 */
@Component({
  components: {
    Pagination,
  },
})
export default class InstallerList extends Vue {
  private newUser: RegisterReq = <RegisterReq>{};

  public reset() {
    this.newUser = <RegisterReq>{};
  }
  public async add() {
    (this.$refs.form as ElForm).validate((valid: boolean) => {
      if (valid) {
        this.addRequest();
      } else {
        return false;
      }
    });
  }

  public async addRequest() {
    this.newUser.appUserType = 1;
    let req = <CreateInstallUserReq>{};
    req.userIDString = this.newUser.userID;
    req.email = this.newUser.email;
    req.password = this.newUser.password;
    req.userName = this.newUser.userName;
    req.confirmPassword = this.newUser.confirmPassword;
    const res = await createInstallUser(req);
    if (res && res.code === ResCode.SUCCESS) {
      this.$notify({
        title: this.$t("common.success").toString(),
        message: this.$t("notification.addInstallUserSuccess").toString(),
        type: "success",
      });
      this.$router.push("/user/installerUsers");
    }
  }

  private created() {}

  public dataRules = {
    userID: [
      { required: true, trigger: "blur", validator: this.validateNotNull },
    ],
    userName: [
      { required: true, trigger: "blur", validator: this.validateNotNull },
    ],
    email: [
      { required: true, trigger: "blur", validator: this.validateNotNull },
    ],
    password: [
      { required: true, trigger: "blur", validator: this.validatePass },
    ],
    confirmPassword: [
      { required: true, trigger: "blur", validator: this.validatePass2 },
    ],
  };
  private validatePass(rule: any, value: string, callback: any) {
    if (value.length < 8) {
      callback(
        new Error(this.$t("validate.passwordMustGreaterThan8").toString())
      );
    } else {
      callback();
    }
  }

  private validatePass2(rule: any, value: string, callback: any) {
    if (value !== this.newUser.password) {
      callback(new Error(this.$t("validate.twoPasswordNotEqual").toString()));
    } else {
      callback();
    }
  }
  private validateNotNull(rule: any, value: string, callback: any) {
    if (!value || value.length <= 0) {
      callback(new Error(this.$t("validate.valueNotNull").toString()));
    } else {
      callback();
    }
  }
}
